import styled, { css } from 'styled-components'
import { breakpoint, size } from '../layout/styles'

export const Grid = styled.div<any>`
  display: flex;
  flex-direction: ${props => props.fixed ? 'row' : 'column'};
  @media ${breakpoint.desktop} {
    flex-direction: ${props => props.reverse ? 'row-reverse' : 'row'};
  }
  ${props => props.md && css `
    &::after {
      content: "";
      flex: auto;
      @media ${breakpoint.desktop} {
        flex: ${props.md};
      }
    }
  `}
`

export const Cell = styled.div<any>`
  flex: ${props => props.xs ? props.xs : '1 1 auto'};
  ${props => props.md && css`
    @media ${breakpoint.desktop} {
      flex: ${props.md};
    }
  `}
  ${props => props.lg && css`
    @media (min-width: 1200px) {
      flex: ${props.lg};
    }
  `}

  ${props => props.gap && css`
    @media ${breakpoint.desktop} {
        margin-left: ${props.gap * 30}px;
    }
  `};

  ${props => props.noprint && css`
    @media print {
      display: none;
    }
  `};
`

export default Grid

export const Column = styled.div<any>`

`